module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"download":"Abrir"},"en":{"download":"Open"},"es":{"download":"Abrir"}}')
  delete Component.options._Ctor
}
